import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Notification {
  id: string;
  type: 'info' | 'warning' | 'success' | 'error';
  title: string;
  message: string;
  timestamp: Date;
  read: boolean;
  link?: string;
}

@Component({
  selector: 'app-layout-notifications-panel',
  templateUrl: './layout-notifications-panel.component.html',
  styleUrls: ['./layout-notifications-panel.component.scss'],
})
export class LayoutNotificationsPanelComponent {
  @Input() notifications: Notification[] = [];
  @Output() notificationClick = new EventEmitter<Notification>();
  @Output() clearAll = new EventEmitter<void>();

  getRelativeTime(date: Date): string {
    const now = new Date();
    const diffMs = now.getTime() - new Date(date).getTime();
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays}d ago`;
    return new Date(date).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
    });
  }

  getNotificationIcon(type: string): string {
    switch (type) {
      case 'success':
        return 'check_circle';
      case 'warning':
        return 'warning';
      case 'error':
        return 'error';
      default:
        return 'info';
    }
  }

  onNotificationClick(event: Event, notification: Notification): void {
    event.stopPropagation();
    this.notificationClick.emit(notification);
  }

  onClearAll(event: Event): void {
    event.stopPropagation();
    this.clearAll.emit();
  }

  get unreadCount(): number {
    return this.notifications.filter(n => !n.read).length;
  }
}
